const ROOT_SELECTOR = "[data-berlinfotografie-nav-root]"
const TOGGLE_SELECTOR = "[data-berlinfotografie-nav-toggle]"
const OVERLAY_SELECTOR = "[data-berlinfotografie-nav-overlay]"
const OPEN_CLASS = "is-open"
const BODY_OPEN_CLASS = "berlinfotografie-mobile-nav-open"
let listenersBound = false

const ensureOverlayMountedAtBody = (overlay) => {
  if (!overlay || overlay.dataset.berlinfotografieOverlayMounted === "true") return

  document.body.appendChild(overlay)
  overlay.dataset.berlinfotografieOverlayMounted = "true"
}

const setMenuState = ({ toggle, overlay, expanded, immediate = false }) => {
  toggle.setAttribute("aria-expanded", expanded ? "true" : "false")
  toggle.classList.toggle("is-active", expanded)
  overlay.setAttribute("aria-hidden", expanded ? "false" : "true")
  document.body.classList.toggle(BODY_OPEN_CLASS, expanded)

  if (expanded) {
    overlay.hidden = false

    requestAnimationFrame(() => {
      overlay.classList.add(OPEN_CLASS)
    })

    return
  }

  overlay.classList.remove(OPEN_CLASS)

  if (immediate) {
    overlay.hidden = true
    return
  }

  const hideOverlay = () => {
    if (overlay.classList.contains(OPEN_CLASS)) {
      return
    }

    overlay.hidden = true
    overlay.removeEventListener("transitionend", hideOverlay)
  }

  overlay.addEventListener("transitionend", hideOverlay)

  window.setTimeout(() => {
    if (!overlay.classList.contains(OPEN_CLASS)) {
      overlay.hidden = true
      overlay.removeEventListener("transitionend", hideOverlay)
    }
  }, 380)
}

const getNavElements = (root) => {
  const toggle = root.querySelector(TOGGLE_SELECTOR)
  const overlayId = toggle?.getAttribute("aria-controls")
  const overlay = (overlayId && document.getElementById(overlayId)) || root.querySelector(OVERLAY_SELECTOR)

  return { toggle, overlay }
}

const getToggleForOverlay = (overlay) => {
  if (!overlay.id) return null

  return document.querySelector(`${TOGGLE_SELECTOR}[aria-controls="${overlay.id}"]`)
}

const closeAllOverlays = ({ immediate = false } = {}) => {
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    const { toggle, overlay } = getNavElements(root)
    if (!toggle || !overlay) return

    setMenuState({
      toggle,
      overlay,
      expanded: false,
      immediate
    })
  })
}

const handleDocumentClick = (event) => {
  const toggle = event.target.closest(TOGGLE_SELECTOR)
  if (toggle) {
    event.preventDefault()

    const root = toggle.closest(ROOT_SELECTOR)
    if (!root) return

    const { overlay } = getNavElements(root)
    if (!overlay) return

    const isExpanded = toggle.getAttribute("aria-expanded") === "true"
    if (isExpanded) {
      setMenuState({ toggle, overlay, expanded: false })
      return
    }

    closeAllOverlays()
    setMenuState({ toggle, overlay, expanded: true })
    return
  }

  const overlay = event.target.closest(OVERLAY_SELECTOR)
  if (!overlay) return

  if (event.target === overlay || event.target.closest("a")) {
    const toggle = getToggleForOverlay(overlay)
    if (!toggle) return

    setMenuState({ toggle, overlay, expanded: false })
  }
}

const bindGlobalListeners = () => {
  if (listenersBound) return

  listenersBound = true
  document.addEventListener("click", handleDocumentClick)
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeAllOverlays()
    }
  })
}

const initOverlays = () => {
  bindGlobalListeners()

  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    const { toggle, overlay } = getNavElements(root)
    if (!toggle || !overlay) return

    ensureOverlayMountedAtBody(overlay)

    setMenuState({
      toggle,
      overlay,
      expanded: false,
      immediate: true
    })
  })
}

document.addEventListener("DOMContentLoaded", initOverlays)
document.addEventListener("turbo:load", initOverlays)

document.addEventListener("turbo:before-cache", () => {
  closeAllOverlays({ immediate: true })
})
